import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { ToolManagament } from '../tool-managament';
import { ToolManagamentRebuildOptionBuilder } from './tool-managament-rebuild-option.builder';

export class ToolManagamentBuilder {
  static fromJson(json) {
    return (json)
      ? new ToolManagament(
        json.hash,
        json.name,
        json.erp,
        parseNumber(json.stockNumber),
        parseNumber(json.toStoreCounter),
        parseNumber(json.inUseCounter),
        parseNumber(json.toRebuildCounter),
        parseNumber(json.toValidateCounter),
        parseNumber(json.toErpCounter),
        parseNumber(json.toRebuildThisToolCounter),
        parseNumber(json.orderQuantity),
        parseNumber(json.requestQuantity),
        json.isToolPublic,
        json.isToolHolderPublic,
        json.categoryName,
        json.restockError,
        ToolManagamentRebuildOptionBuilder.fromList(json.options)
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ToolManagamentBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/tool-managament.builder.ts